/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import React, { useState } from "react";
import { Animated, View } from "react-native";

import sessionImage from "assets/session-image.png";
import { getResizedImageUrl } from "config/Utilities";

export default function SessionImage({ uri, duration }) {
  const [thumbnailOpacity] = useState(new Animated.Value(1));
  const onSessionImageLoad = () => {
    Animated.timing(thumbnailOpacity, {
      toValue: 0,
      duration: 250,
      useNativeDriver: false,
    }).start();
  };
  if (duration && uri && !uri.includes("/None.png")) {
    return (
      <View
        style={{
          width: 70,
          height: 50,
        }}
      >
        <Animated.Image
          style={[
            {
              opacity: thumbnailOpacity,
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              borderRadius: 8,
            },
          ]}
          source={sessionImage}
        />
        <Animated.Image
          style={[
            {
              position: "absolute",
              top: 0,
              bottom: 0,
              left: 0,
              right: 0,
              borderRadius: 8,
            },
          ]}
          source={{
            uri: uri.startsWith("http") ? getResizedImageUrl(uri, 60, 38) : uri,
          }}
          onLoad={() => onSessionImageLoad()}
        />
      </View>
    );
  }
  return null;
}
